<template>
  <v-data-table
    :headers="headers"
    :items="items"
    class="border"
    density="compact"
    :hide-default-header="noHeader"
    hide-default-footer
  >
    <template
      v-slot:[`item.${header.value}`]="{ item }"
      v-for="(header, index) in headers"
    >
      <td
        :class="getColumnClass(index)"
        :style="{
          backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
          fontWeight: 500
        }"
        :key="`${item.id}-${header.value}`"
      >
        {{ formatValue(item[header.value]) }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { getColumnClass, formatValue, PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'
export default {
  props: {
    headers: Array,
    items: Array,
    noHeader: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getColumnClass,
      formatValue,
      PAYMENT_CERTIFICATE_TABLE_COLOR
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px solid #000;
  border-radius: 0;
}
.custom-text-width {
  width: 150px;
}
.column-width {
  min-width: 250px;
}
</style>
